import { render, staticRenderFns } from "./fr4Form.vue?vue&type=template&id=10d4e4c6&scoped=true"
import script from "./fr4Form.vue?vue&type=script&lang=js"
export * from "./fr4Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d4e4c6",
  null
  
)

export default component.exports